import { makeStyles } from "@material-ui/core";
import { whiteGrey, white } from "../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  mainForm: {
    backgroundColor: white,
    padding: "30px 60px",
    [down("sm")]: {
      padding: "30px 40px",
    },
    [down("xs")]: {
      padding: "25px 10px",
    },
  },
  secondaryForm: {
    backgroundColor: whiteGrey,
    padding: "40px",
    alignItems: "flex-start",
    [down("sm")]: {
      padding: "30px 40px",
      backgroundColor: white,
    },
    [down("xs")]: {
      backgroundColor: white,
      padding: "0px 10px",
      paddingBottom: "30px",
    },
  },
  ticketHeader: {
    position: "relative",
    [down("xs")]: {
      display: "none",
    },
  },
  absolute: {
    position: "absolute",
    top: 0,
    right: 0,
  },
  formHeader: {
    [down("xs")]: {
      "& p": {
        fontSize: "12px",
      },
    },
  },
  itinerarySection: {
    marginTop: "50%",
    [down("sm")]: {
      marginTop: 0,
    },
  },
}));

export default useStyles;
